import { useUserProfile } from "../../features/auth/hooks/useUserProfile";

export type GradePreference = "v-scale" | "font";

/**
 * Hook to get the user's grade preference from their profile.
 * Returns 'v-scale' as default if no preference is set or user is not logged in.
 */
export const useGradePreference = (): GradePreference => {
  const { data: userProfile } = useUserProfile();

  // Return user's preference or default to v-scale
  return userProfile?.grade_preference || "v-scale";
};
